export const LOAD_ADMIN_USERS = {
  BEGIN: "LOAD_ADMIN_USERS_BEGIN",
  SUCCESS: "LOAD_ADMIN_USERS_SUCCESS",
  FAILURE: "LOAD_ADMIN_USERS_FAILURE"
};

const LOAD_SINGLE_USER = {
  BEGIN: "LOAD_SINGLE_USER_BEGIN",
  SUCCESS: "LOAD_SINGLE_USER_SUCCESS",
  FAILURE: "LOAD_SINGLE_USER_FAILURE"
};

const DELETE_SINGLE_USER_DASHBOARD = {
  BEGIN: "DELETE_SINGLE_USER_DASHBOARD_BEGIN",
  SUCCESS: "DELETE_SINGLE_USER_DASHBOARD_SUCCESS",
  FAILURE: "DELETE_SINGLE_USER_DASHBOARD_FAILURE"
};

const UPDATE_SINGLE_USER_DASHBOARD = {
  BEGIN: "UPDATE_SINGLE_USER_DASHBOARD_BEGIN",
  SUCCESS: "UPDATE_SINGLE_USER_DASHBOARD_SUCCESS",
  FAILURE: "UPDATE_SINGLE_USER_DASHBOARD_FAILURE"
};

const ADD_NEW_DASHBOARDS = {
  BEGIN: "ADD_NEW_DASHBOARDS_BEGIN",
  SUCCESS: "ADD_NEW_DASHBOARDS_SUCCESS",
  FAILURE: "ADD_NEW_DASHBOARDS_FAILURE"
};

const UPDATE_USER_ROLE = {
  BEGIN: "UPDATE_USER_ROLE_BEGIN",
  SUCCESS: "UPDATE_USER_ROLE_SUCCESS",
  FAILURE: "UPDATE_USER_ROLE_FAILURE"
};

const UPDATE_USER_APPLICATIONS = {
  BEGIN: "UPDATE_USER_APPLICATIONS_BEGIN",
  SUCCESS: "UPDATE_USER_APPLICATIONS_SUCCESS",
  FAILURE: "UPDATE_USER_APPLICATIONS_FAILURE"
};

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_ADMIN_USERS.SUCCESS: {
      let { allUsers: users } = action.payload;
      const sambaUsers = users.filter(
        user => user.email.indexOf("@samba.tv") > -1
      );
      const otherUsers = users.filter(
        user => user.email.indexOf("@samba.tv") === -1
      );
      users = sambaUsers.concat(otherUsers);

      users = users.reduce((acc, user) => {
        acc[user.userId] = user;
        return acc;
      }, {});
      return { ...users };
    }
    case LOAD_SINGLE_USER.SUCCESS: {
      const user = action.payload;
      return { ...state, [user.userId]: { ...state[user.userId], ...user } };
    }
    case DELETE_SINGLE_USER_DASHBOARD.SUCCESS: {
      const { userId, dashboardId } = action.payload;

      const dashboardName =
        state[userId].dashboards[dashboardId].dashboard.name;
      const message = `${dashboardName} is successfully deleted!`;

      delete state[userId].dashboards[dashboardId];

      state[userId] = { ...state[userId], message };
      return { ...state };
    }
    case UPDATE_SINGLE_USER_DASHBOARD.SUCCESS: {
      const { filters, dashboardId, userId } = action.payload;
      state[userId].dashboards[dashboardId].filters = filters;
      const dashboardName =
        state[userId].dashboards[dashboardId].dashboard.name;
      const message = `${dashboardName} is successfully updated!`;
      state[userId] = { ...state[userId], message };
      return { ...state };
    }
    case ADD_NEW_DASHBOARDS.SUCCESS: {
      const message = "New dashboard is successfully added!";
      const { userId } = action.payload;
      return { ...state, [userId]: { ...action.payload, message } };
    }
    case UPDATE_USER_ROLE.SUCCESS: {
      const user = action.payload;
      return { ...state, [user.userId]: user };
    }
    case UPDATE_USER_APPLICATIONS.SUCCESS: {
      const { userId, applications } = action.payload;
      return { ...state, [userId]: { ...state[userId], applications } };
    }
    default:
      return state;
  }
}
/* Actions */
export const loadAdminUsers = (page, query) => {
  return {
    types: [
      LOAD_ADMIN_USERS.BEGIN,
      LOAD_ADMIN_USERS.SUCCESS,
      LOAD_ADMIN_USERS.FAILURE
    ],
    api: api => api.loadAdminUsers(page, query)
  };
};

export const loadSingleUser = id => {
  return {
    types: [
      LOAD_SINGLE_USER.BEGIN,
      LOAD_SINGLE_USER.SUCCESS,
      LOAD_SINGLE_USER.FAILURE
    ],
    api: api => api.loadSingleUser(id)
  };
};

export const deleteUserDashboard = (userId, userDashboardId, dashboardId) => {
  return {
    types: [
      DELETE_SINGLE_USER_DASHBOARD.BEGIN,
      DELETE_SINGLE_USER_DASHBOARD.SUCCESS,
      DELETE_SINGLE_USER_DASHBOARD.FAILURE
    ],
    api: api => api.deleteUserDashboard(userId, userDashboardId, dashboardId)
  };
};

export const updateUserDashboard = (
  userId,
  userDashboardId,
  dashboardId,
  filterIds
) => {
  return {
    types: [
      UPDATE_SINGLE_USER_DASHBOARD.BEGIN,
      UPDATE_SINGLE_USER_DASHBOARD.SUCCESS,
      UPDATE_SINGLE_USER_DASHBOARD.FAILURE
    ],
    api: api =>
      api.updateUserDashboard(userId, userDashboardId, dashboardId, filterIds)
  };
};

export const addNewUserDashboards = (
  userId,
  dashboardFilters,
  notifyUser,
  notifyFinance
) => {
  return {
    types: [
      ADD_NEW_DASHBOARDS.BEGIN,
      ADD_NEW_DASHBOARDS.SUCCESS,
      ADD_NEW_DASHBOARDS.FAILURE
    ],
    api: api =>
      api.addNewUserDashboards(
        userId,
        dashboardFilters,
        notifyUser,
        notifyFinance
      )
  };
};

export const updateUserRole = body => {
  return {
    types: [
      UPDATE_USER_ROLE.BEGIN,
      UPDATE_USER_ROLE.SUCCESS,
      UPDATE_USER_ROLE.FAILURE
    ],
    api: api => api.updateUserRole(body)
  };
};

export const getUserApplications = userId => {
  return {
    types: [
      UPDATE_USER_APPLICATIONS.BEGIN,
      UPDATE_USER_APPLICATIONS.SUCCESS,
      UPDATE_USER_APPLICATIONS.FAILURE
    ],
    api: api => api.getUserApplications(userId)
  };
};

export const updateUserApplications = (userId, body) => {
  return {
    types: [
      UPDATE_USER_APPLICATIONS.BEGIN,
      UPDATE_USER_APPLICATIONS.SUCCESS,
      UPDATE_USER_APPLICATIONS.FAILURE
    ],
    api: api => api.updateUserApplications(userId, body)
  };
};

/* Getters */
export const searchUsers = (users, searchValue, hideSambaEmployees) => {
  users = Object.values(users).filter(
    user =>
      (user.givenName
        ? user.givenName.toLowerCase().indexOf(searchValue) > -1
        : false) ||
      (user.familyName
        ? user.familyName.toLowerCase().indexOf(searchValue) > -1
        : false) ||
      (user.name ? user.name.toLowerCase().indexOf(searchValue) > -1 : false) ||
      (user.email ? user.email.toLowerCase().indexOf(searchValue) > -1 : false)
  );

  if (hideSambaEmployees) {
    users = Object.values(users).filter(
      user => user.email.indexOf("samba.tv") < 0
    );
  }

  if (!users.length) {
    return {};
  }

  return users.reduce((acc, user) => {
    acc[user.userId] = user;
    return acc;
  }, {});
};
